import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TwitterIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 32,
  height = 32,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M13.3,25 C16.4731953,25.0582197 19.5293798,23.8024773 21.7449607,21.5300867 C23.9605416,19.257696 25.1385223,16.1707049 25,13 C25.8,12.4 26.5,11.7 27,10.9 C26.3,11.2 25.5,11.4 24.6,11.5 C25.4491174,11.0117805 26.0895903,10.2289803 26.4,9.3 C25.7,9.8 24.8,10.1 23.8,10.3 C22.6534718,9.14915711 20.9355984,8.78377262 19.419947,9.36838103 C17.9042955,9.95298944 16.8767424,11.3773242 16.8,13 L16.8,14 C13.4,13.8 10.4,12.2 8.4,9.7 C7.30929579,11.5565065 7.88388992,13.9432821 9.7,15.1 C9,15.1 8.4,14.9 7.8,14.6 C7.7697557,16.5623486 9.16766268,18.2567813 11.1,18.6 C10.4826546,18.7782354 9.83264444,18.8124465 9.2,18.7 C9.8,20.3 11.2,21.5 13.1,21.5 C11.3712309,22.8505416 9.17809448,23.4617436 7,23.2 C8.8,24.3 11,25 13.3,25"
        data-testid="icon-twitter"
        fill="#ffffff"
        className={styles.white}
      />
    </Icon>
  )
}
